import React from 'react';
import { Star } from 'lucide-react';
import BBB from 'assets/images/BBB.png';
import GoogleCloud from 'assets/images/GoogleCloud.png';
import GooglePartner from 'assets/images/GooglePartner.png';

const TrustSection = () => {
  return (
    <div className="w-full">
      {/* Banner azul superior */}
      <div className="bg-red-600 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            
            {/* Lado izquierdo - Estrellas y texto */}
            <div className="text-center lg:text-left">
              <div className="flex justify-center lg:justify-start items-center space-x-1 mb-6">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-8 h-8 text-white fill-current" />
                ))}
              </div>
              <h2 className="text-2xl lg:text-3xl font-bold text-white leading-tight">
                A Leading Digital Marketing Agency For Small and Mid-Sized Businesses
              </h2>
            </div>

            {/* Lado derecho - Estadísticas */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="text-4xl lg:text-5xl font-bold text-white mb-2">15+</div>
                <div className="text-white text-sm font-medium">YEARS IN BUSINESS</div>
              </div>
              <div className="text-center">
                <div className="text-4xl lg:text-5xl font-bold text-white mb-2">1K+</div>
                <div className="text-white text-sm font-medium">ONLINE REVIEWS</div>
              </div>
              <div className="text-center">
                <div className="text-4xl lg:text-5xl font-bold text-white mb-2">50K+</div>
                <div className="text-white text-sm font-medium">CURRENT CLIENTS</div>
              </div>
              <div className="text-center">
                <div className="text-4xl lg:text-5xl font-bold text-white mb-2">2M+</div>
                <div className="text-white text-sm font-medium">LEADS</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tarjetas de certificaciones */}
      <div className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            
            {/* Tarjeta 1 - Google Certified Partner */}
            <div className="bg-white rounded-lg shadow-lg p-8 text-center hover:shadow-xl transition-shadow">
              {/* Logo Google Partner */}
              <div className="mb-6">
                <div className="h-24 mx-auto bg-white flex items-center justify-center mb-4">
                  <img src={GooglePartner} alt="google partner" />
                </div>
              </div>
              
              <h3 className="text-xl font-bold text-gray-800 mb-4">Google Certified Partner</h3>
              <p className="text-gray-600 leading-relaxed">
                The Google Partner badge shows specific Partners have passed Google Ads product certification exams and are up to date with the latest product knowledge.
              </p>
            </div>

            {/* Tarjeta 2 - Google Cloud Partner */}
            <div className="bg-white rounded-lg shadow-lg p-8 text-center hover:shadow-xl transition-shadow">
              {/* Logo Google Cloud */}
              <div className="mb-6">
                <div className="h-24 mx-auto bg-white flex items-center justify-center mb-4">
                  <img src={GoogleCloud} alt="google cloud" />
                </div>
              </div>
              
              <h3 className="text-xl font-bold text-gray-800 mb-4">Google Cloud Partner</h3>
              <p className="text-gray-600 leading-relaxed">
                This badge denotes the interaction with and building upon Google's products to develop innovative solutions and opportunities for businesses to connect with customers.
              </p>
            </div>

            {/* Tarjeta 3 - BBB */}
            <div className="bg-white rounded-lg shadow-lg p-8 text-center hover:shadow-xl transition-shadow">
              {/* Logo BBB */}
              <div className="mb-6">
                <div className="h-24 mx-auto bg-white flex items-center justify-center mb-4">
                  <img src={BBB} alt="BBB" />
                </div>
              </div>
              
              <h3 className="text-xl font-bold text-gray-800 mb-4">BBB</h3>
              <p className="text-gray-600 leading-relaxed">
                The BBB Trust Seal badge indicates that a business has been accredited by the Better Business Bureau, demonstrating a commitment to ethical business practices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustSection;





